var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useEffect, useReducer, useRef, } from "react";
import isEmpty from "lodash-es/isEmpty";
import { AccountContext, DEFAULT_ACCOUNT_CONTEXT_STATE, } from "./context";
/**
 * @deprecated Use OneAccount.Provider Instead
 *
 * @param {*} props
 * @return {*}
 */
export var AccountProvider = function (props) {
    var sdkReady = props.sdkReady, _a = props.customLoginDialog, customLoginDialog = _a === void 0 ? false : _a, onLogin = props.onLogin, onError = props.onError, children = props.children;
    var _b = __read(useReducer(function (state, payload) {
        if (isEmpty(payload))
            return state;
        // TODO 做浅比较，避免重新渲染
        return __assign(__assign({}, state), payload);
    }, __assign(__assign({}, DEFAULT_ACCOUNT_CONTEXT_STATE), { loading: true })), 2), state = _b[0], dispatch = _b[1];
    var eventsRef = useRef({ login: [], logout: [] });
    // 注册 onLogin 事件
    useEffect(function () {
        var events = eventsRef.current;
        if (onLogin) {
            events.login.unshift(onLogin);
            return function () {
                var idx = events.login.indexOf(onLogin);
                if (idx > -1) {
                    events.login.splice(idx, 1);
                }
            };
        }
    }, [onLogin]);
    return (_jsxs(AccountContext.Provider, { value: {
            active: true,
            events: eventsRef.current,
            onError: onError || (function (_, err) { return console.error(err); }),
            customLoginDialog: customLoginDialog,
            sdkReady: sdkReady,
            state: state,
            dispatch: dispatch,
        }, children: [_jsx(Setup, {}), children] }));
};
export var HgAccountProvider = AccountProvider;
export var GlAccountProvider = AccountProvider;
function Setup() {
    var _this = this;
    var _a = useContext(AccountContext), sdkReady = _a.sdkReady, dispatch = _a.dispatch;
    useEffect(function () {
        if (sdkReady.SDK_TYPE === "HG") {
            sdkReady(function (sdk) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    dispatch({
                        loading: true,
                    });
                    sdk.User.UI.checkSession({}, function (status, data) {
                        if (status === 0 && data) {
                            dispatch({
                                ready: true,
                                loading: false,
                                account: data.hgInfo,
                            });
                        }
                        else {
                            dispatch({
                                ready: true,
                                loading: false,
                            });
                        }
                    });
                    return [2 /*return*/];
                });
            }); });
        }
        else if (sdkReady.SDK_TYPE === "GL") {
            sdkReady(function (sdk) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    dispatch({
                        loading: true,
                    });
                    sdk.user.checkSession({}, function (status, data) {
                        if (status === 0 && data) {
                            dispatch({
                                ready: true,
                                loading: false,
                                account: data.accountInfo,
                            });
                        }
                        else {
                            dispatch({
                                ready: true,
                                loading: false,
                            });
                        }
                    });
                    return [2 /*return*/];
                });
            }); });
        }
    }, []);
    return null;
}
